<section>
  <div class="d-flex flex-row justify-content-between align-items-center w-100">
    <h4 class="my-1">Delete table</h4>

    <tr-icon [icon]="icon.cancel" (click)="cancel()" classes="close-btn"></tr-icon>
  </div>

  <div class="field-container pb-3 pt-4">
    <h2>You are about to remove {{ resourceName }} from the floorplan. Do you want to delete the underlying resource as well?</h2>

    <div class="field-item d-flex mt-3">
      <input type="checkbox" [formControl]="deleteResources" />
      <p class="mb-0 ml-2">Yes, delete the resource</p>
    </div>
  </div>

  <div class="actions w-100 pt-3">
    <button class="btn btn-info mr-2 px-5" (click)="delete()">Confirm</button>
    <button class="btn btn-danger ml-2 px-5" (click)="cancel()">Decline</button>
  </div>
</section>
